export default __webpack_public_path__ + "static/media/join_background_left.c27f9246.png";